import { CommApiInstance } from "Utils/CommApiInstance";


const DpstOdrInfotApi = async (
    gameSvcCd:string    ,
    DpstOdrNo:string   ,
    langCd:string
) => {
    return await CommApiInstance.post(`${"/pymt/"+gameSvcCd+"/odr/"+DpstOdrNo}`, {
        apiBody: {
            langCd:langCd
        }
    })
    .then((Resp) => Resp.data);
}

export default DpstOdrInfotApi;
